document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {

    var qtyInput = document.querySelector('#quantity-select-pdp');
    if (!qtyInput) return;

    var min = parseInt(qtyInput.getAttribute('min')) || 1;

    // Set initial value to MOQ
    if (parseInt(qtyInput.value) < min) {
      qtyInput.value = min;
    }

    // On manual change — snap to nearest valid multiple of min
    qtyInput.addEventListener('change', function() {
      var val = parseInt(this.value) || min;
      if (val < min) {
        this.value = min;
      } else {
        // Snap to nearest multiple of min
        var remainder = val % min;
        if (remainder !== 0) {
          this.value = val + (min - remainder);
        }
      }
    });

  }, 500);
});